import React from "react";

const SingleColumnLayout = ({
  children,
  centered = false,
}: {
  children: React.ReactNode;
  centered?: boolean;
}) => {
  return (
    <section className={`bwp-single-column-layout${centered ? " bwp-single-column-layout--centered" : ""}`}>
      <div className="bwp-single-column-layout__stack">{children}</div>
    </section>
  )
}

export default SingleColumnLayout;